import React, { Component } from 'react';
import { withStyles } from '@material-ui/styles';
import { withRouter } from 'react-router-dom';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Button from '@material-ui/core/Button';

import axiosInstance, { WEB_API, EVENT_ID } from '../constatns';
import Topbar from '../components/Topbar';
import Footer from '../components/Footer';
import Container from '../components/Div/Container';
import MainTitle from '../components/Text/MainTitle';

const moment = require('moment');

const styles = (theme) => ({});

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: '#F4F5F9',
    color: '#222222',
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({}))(TableRow);

class BbsDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.goToPage = this.goToPage.bind(this);
    this.getSelectedBbsDetail = this.getSelectedBbsDetail.bind(this);
  }

  componentDidMount() {
    // console.log(this.context);
    if (
      window.screen.width < 500 ||
      navigator.userAgent.match(/Android/i) ||
      navigator.userAgent.match(/webOS/i) ||
      navigator.userAgent.match(/iPhone/i) ||
      navigator.userAgent.match(/iPod/i)
    ) {
      this.setState({ matches: true });
    } else {
      this.setState({ matches: false });
    }
    this.getSelectedBbsDetail();
  }
  getSelectedBbsDetail() {
    axiosInstance
      .get(`${WEB_API}/bbs/list?eventId=${EVENT_ID}`)
      .then((response) => {
        // console.log(response.data.Items);
        this.setState({ selectedItem: response.data.Items.find((o) => o.id === this.props.location.search.replace('?', '')) });
      })
      .catch((error) => {
        console.log(error);
      });
  }
  componentWillUnmount() {}

  goToPage(_move) {
    this.props.history.push(_move);
  }

  render() {
    const { classes } = this.props;
    const { selectedItem } = this.state;
    return (
      <React.Fragment>
        <CssBaseline />
        <Topbar MIdx={0} SIdx={0} />
        <Container>
          <Grid container justifyContent={'center'}>
            <Grid id=" content_grid" item xs={8}>
              <MainTitle>News & Notice</MainTitle>
              <div
                style={{
                  textAlign: 'center',
                  margin: '0 auto',
                  padding: this.props.theme.spacing(2, 0),
                  color: '#0b316f',
                  borderTop: '2px solid #0b316f',
                  borderBottom: '1px solid #ccc',
                  fontWeight: 'bold',
                  width: '100%',
                  backgroundColor: '#F9FBFF',
                }}
              >
                {selectedItem && selectedItem.bbsTitle}
              </div>
              <TableContainer style={{ boxShadow: 'none', borderRadius: 0, marginBottom: '1em' }}>
                <Table className={classes.table}>
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell
                        component="th"
                        align="center"
                        style={{
                          backgroundColor: '#F4F5F9',
                          color: this.props.theme.palette.primary.main,
                          fontWeight: 'bold',
                          width: '16.6%',
                        }}
                      >
                        Writer
                      </StyledTableCell>
                      <StyledTableCell align="center" style={{ backgroundColor: '#fff', width: '16.6%' }}>
                        {'PRS KOREA 2022'}
                      </StyledTableCell>

                      <StyledTableCell
                        align="center"
                        style={{
                          backgroundColor: '#F4F5F9',
                          color: this.props.theme.palette.primary.main,
                          fontWeight: 'bold',
                          width: '16.6%',
                        }}
                      >
                        Date
                      </StyledTableCell>
                      <StyledTableCell align="center" style={{ backgroundColor: '#fff', width: '16.6%' }}>
                        {selectedItem && moment(Number(selectedItem.createdAt)).format('YYYY-MM-DD')}
                      </StyledTableCell>
                      <StyledTableCell
                        component="th"
                        align="center"
                        style={{
                          backgroundColor: '#F4F5F9',
                          color: this.props.theme.palette.primary.main,
                          fontWeight: 'bold',
                          width: '16.6%',
                        }}
                      >
                        Hits
                      </StyledTableCell>
                      <StyledTableCell component="th" align="center" style={{ backgroundColor: '#fff', width: '16.6%' }}>
                        {selectedItem && selectedItem.hit}
                      </StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <StyledTableCell colSpan={6}>
                        <Grid container style={{ minHeight: '40vh' }}>
                          {selectedItem && <div style={{ width: '100%' }} dangerouslySetInnerHTML={{ __html: selectedItem.bbsContents }} />}
                        </Grid>
                      </StyledTableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>

              <Grid item xs={12}>
                <Grid container justifyContent="flex-end">
                  <Button
                    color="secondary"
                    className={classes.button}
                    disableElevation
                    variant="contained"
                    onClick={() => this.goToPage('/bbs')}
                    style={{ color: '#fff', fontSize: 'large' }}
                  >
                    List
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Container>
        <Footer />
      </React.Fragment>
    );
  }
}

export default withRouter(withStyles(styles, { withTheme: true })(BbsDetail));
